import { render, staticRenderFns } from "./faqFeedback.vue?vue&type=template&id=05907626&scoped=true&"
import script from "./faqFeedback.vue?vue&type=script&lang=js&"
export * from "./faqFeedback.vue?vue&type=script&lang=js&"
import style0 from "./faqFeedback.vue?vue&type=style&index=0&id=05907626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05907626",
  null
  
)

export default component.exports